module.exports = __webpack_public_path__ + "static/media/home-bg-prime.80469a24.jpg";